import urls from "../../global/constants/UrlConstants";
import { getNoAuthCallParams, makeCall } from "../../utils/service";

export async function practicesData(locale: string) {
  try {
    const url = urls.getGoodPracticesData + "/" + locale;
    const callParams = await getNoAuthCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}
